import styled from 'styled-components';

// error container
export const ErrorContainer = styled.div`
    color: #ff0000;
`;